import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { AModalConsentimento } from "@/components/Gerais"
  import { computed } from "vue"
  import { usuarioStore } from "@/store/usuarios/usuario/usuario.store"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const { verificarSeUsuarioConsentiuComCookies } = usuarioStore()

  const deveMostrarModalDeConsentimento = computed(
    () => verificarSeUsuarioConsentiuComCookies() === null
  )

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(deveMostrarModalDeConsentimento))
      ? (_openBlock(), _createBlock(_unref(AModalConsentimento), { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(_component_Toast, {
      position: "top-right",
      style: { minWidth: '560px', zIndex: '2000' }
    })
  ], 64))
}
}

})